import * as actionTypes from "../actions/actionTypes";

const initialState = {
    show: false,
    id: null,
    details: null,
    loading: false,
    error: false,
    errorMessage: null,
    errorCode: null,
};

const loadSpecificListingStart = (state, action) => {
    return {
        ...state,
        loading: true,
        error: false,
        id: action.id,
    };
};

const loadSpecificListingSuccess = (state, action) => {
    return {
        ...state,
        loading: false,
        details: action.data,
    };
};

const loadSpecificListingFail = (state, action) => {
    return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.errorMessage,
        errorCode: action.errorCode,
    };
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.LOAD_SPECIFIC_LISTING_START:
            return loadSpecificListingStart(state, action);
        case actionTypes.LOAD_SPECIFIC_LISTING_SUCCESS:
            return loadSpecificListingSuccess(state, action);
        case actionTypes.LOAD_SPECIFIC_LISTING_FAIL:
            return loadSpecificListingFail(state, action);
        default:
            return state;
    }
};

export default reducer;
